export const V8_EDUCATION_LEVELS_COMP_SURVEY = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true,
  },
  {
    value: 'SOME_HIGH_SCHOOL_OR_LESS',
    label:
      /* TRANSLATORS: education level */
      getText('Some High School or Less'),
  },
  {
    value: 'HIGH_SCHOOL_DIPLOMA_GED',
    label:
      /* TRANSLATORS: education level */
      getText('High School Diploma / G.E.D.'),
  },
  {
    value: '2_YEAR_DEGREE',
    label:
      /* TRANSLATORS: education level */
      getText('2-Year Degree'),
  },
  {
    value: '4_YEAR_DEGREE',
    label:
      /* TRANSLATORS: education level */
      getText('4-Year Degree'),
  },
  {
    value: 'MASTERS_DEGREE',
    label:
      /* TRANSLATORS: education level */
      getText("Master's Degree (M.A., M.B.A., etc.)"),
  },
  {
    value: 'JURIS_DOCTOR',
    label:
      /* TRANSLATORS: education level */
      getText('Juris Doctor (J.D.)'),
  },
  {
    value: 'DOCTORATE',
    label:
      /* TRANSLATORS: education level */
      getText('Doctorate (Ph.D.)'),
  },
  {
    value: 'MEDICAL_DOCTOR',
    label:
      /* TRANSLATORS: education level */
      getText('Medical Doctor (M.D.)'),
  },
];
export const V8_NUMBER_OF_FT_EMPLOYEES_BUCKETS = [
  {
    value: '',
    label: getText('Select One'),
  },
  {
    value: '1_TO_10',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('1-10'),
  },
  {
    value: '11_TO_25',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('11-25'),
  },
  {
    value: '26_TO_50',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('26-50'),
  },
  {
    value: '51_TO_100',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('51-100'),
  },
  {
    value: '101_TO_250',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('101-250'),
  },
  {
    value: '251_TO_500',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('251-500'),
  },
  {
    value: '501_TO_1000',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('501-1000'),
  },
  {
    value: 'GT_1000',
    label:
      /* TRANSLATORS: employer budget buckets */
      getText('>1000'),
  },
];
const ISSUE_BASED_ORGANIZATION_SUB_TYPES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true,
  },
  {
    value: 'AGRICULTURE',
    label: getText('Agriculture'),
    description: getText(
      'Nonprofits in this space focus on issues related to farming, farmers, farm animals, and land sustainability.',
    ),
  },
  {
    value: 'ANIMALS',
    label: getText('Animals'),
    description: getText(
      'Nonprofits in this space focus on establishing and protecting the rights of all animals.',
    ),
  },
  {
    value: 'CIVIC_ENGAGEMENT',
    label: getText('Civic Engagement'),
    description: getText(
      'Nonprofits working to make a difference in the civic life of communities through voting, organizing, and volunteering.',
    ),
  },
  {
    value: 'CLIMATE_CHANGE',
    label: getText('Climate Change'),
    description: getText(
      'Nonprofits focused on climate-focused social movements, advocating for strong and equitable climate policy, and more.',
    ),
  },
  {
    value: 'COMMUNICATIONS_ACCESS',
    label: getText('Communications Access'),
    description: getText(
      'Nonprofits focused on ensuring people have access to news and information, the ability to connect, and the means to make their voices heard through communication.',
    ),
  },
  {
    value: 'COMMUNITY_DEVELOPMENT',
    label: getText('Community Development'),
    description: getText(
      'Nonprofits who bring community members together to take collective action and generate solutions that will benefit the community as a whole.',
    ),
  },
  {
    value: 'CONFLICT_RESOLUTION',
    label: getText('Conflict Resolution'),
    description: getText(
      'Nonprofits that work with individuals, communities, courts, and other institutions to manage and resolve conflict.',
    ),
  },
  {
    value: 'CONSUMER_PROTECTION',
    label: getText('Consumer Protection'),
    description: getText(
      'Nonprofits focused on safeguarding buyers of goods and services, and the public, against unfair practices in the marketplace.',
    ),
  },
  {
    value: 'CRIME_SAFETY',
    label: getText('Crime & Safety'),
    description: getText(
      'Nonprofits focused on prison reform, gun control, domestic violence, and other issues related to decreasing crime rates.',
    ),
  },
  {
    value: 'DISABILITY',
    label: getText('Disability'),
    description: getText(
      'Nonprofits focused on supporting and advancing the rights of individuals with disabilities through direct service, programs, and advocacy.',
    ),
  },
  {
    value: 'DISASTER_RELIEF',
    label: getText('Disaster Relief'),
    description: getText(
      'Nonprofits that respond to catastrophic situations, providing humanitarian aid to communities impacted by some form of disaster.',
    ),
  },
  {
    value: 'ECONOMIC_DEVELOPMENT',
    label: getText('Economic Development'),
    description: getText(
      'Nonprofits invested in improving a local community’s economic conditions and opportunities, often with consideration for social equity and sustainability, using various methods such as increasing affordable housing or offering small business loans.',
    ),
  },
  {
    value: 'EDUCATION',
    label: getText('Education'),
    description: getText(
      'Nonprofits in this space may offer afterschool programs, citizenship classes, training opportunities, or tutoring.',
    ),
  },
  {
    value: 'ENERGY',
    label: getText('Energy'),
    description: getText(
      'Nonprofits focused on energy research, sustainable energy, and promoting energy efficiency.',
    ),
  },
  {
    value: 'ENTREPRENEURSHIP',
    label: getText('Entrepreneurship'),
    description: getText(
      'Nonprofits focused on educating and encouraging entrepreneurs to succeed in building companies, as well as personal and professional development.',
    ),
  },
  {
    value: 'ENVIRONMENT',
    label: getText('Environment'),
    description: getText(
      'Nonprofits focused on promoting responsible interaction with the environment to avoid depletion or degradation of natural resources.',
    ),
  },
  {
    value: 'FAMILY',
    label: getText('Family'),
    description: getText(
      'Nonprofits focused on the well-being of the family through services and programs addressing challenges related to education, behavioral issues, health issues, drug addiction, and/or homelessness.',
    ),
  },
  {
    value: 'FINANCIAL_LITERACY_PERSONAL_FINANCE',
    label: getText('Financial Literacy & Personal Finance'),
    description: getText(
      'Nonprofits focused on equipping people with the essential knowledge and skills for life’s crucial financial decisions.',
    ),
  },
  {
    value: 'HEALTH_MEDICINE',
    label: getText('Health & Medicine'),
    description: getText(
      'Focuses on community-based healthcare, global health, specific conditions or diseases, and much more.',
    ),
  },
  {
    value: 'HOUSING_HOMELESSNESS',
    label: getText('Housing & Homelessness'),
    description: getText(
      'Nonprofits focused on assisting people without homes and breaking the cycle of homelessness through outreach, housing, and prevention programming, with the belief that every person deserves a shelter.',
    ),
  },
  {
    value: 'HUMAN_RIGHTS_CIVIL_LIBERTIES',
    label: getText('Human Rights & Civil Liberties'),
    description: getText(
      'Nonprofits focused on defending and preserving the rights of every person and/or the individual rights and liberties guaranteed by the Constitution and laws of the United States.',
    ),
  },
  {
    value: 'HUNGER_FOOD_SECURITY',
    label: getText('Hunger, Food Security'),
    description: getText(
      'Nonprofits focused on alleviating hunger and increasing availability, access, utilization, and stability of food.',
    ),
  },
  {
    value: 'IMMIGRANTS_OR_REFUGEES',
    label: getText('Immigrants or Refugees'),
    description: getText(
      'Nonprofits focused on defending the rights of immigrants and refugees, advocating for and empowering individuals.',
    ),
  },
  {
    value: 'INTERNATIONAL_RELATIONS',
    label: getText('International Relations'),
    description: getText(
      'Nonprofits focused on promoting the exchange of global views and information about international affairs and economics topics.',
    ),
  },
  {
    value: 'JOB_WORKPLACE',
    label: getText('Job & Workplace'),
    description: getText(
      'Nonprofits focused on providing comprehensive employment services, advocating for workers rights, workforce safety, workforce diversity, and more.',
    ),
  },
  {
    value: 'LGBTQ',
    label: getText('LGBTQ'),
    description: getText(
      'Nonprofits focused on rights, issues, services, and advocacy related to the LGBTQ+ community.',
    ),
  },
  {
    value: 'LEGAL_ASSISTANCE',
    label: getText('Legal Assistance'),
    description: getText(
      'Nonprofits focused on ensuring equal access to the justice system for free or at a reduced cost to low income and elderly clients.',
    ),
  },
  {
    value: 'MEDIA',
    label: getText('Media'),
    description: getText(
      'Nonprofits creating mass communications in print, publishing, news, photography, cinema, broadcasting (radio and television), or advertising, usually in the public interest.',
    ),
  },
  {
    value: 'MEN',
    label: getText('Men'),
    description: getText(
      'Nonprofits focused on issues that are more likely to affect men, such as specific health issues, incarceration, male mentorship, and more.',
    ),
  },
  {
    value: 'MENTAL_HEALTH',
    label: getText('Mental Health'),
    description: getText(
      'Nonprofits focused on promoting and providing services around mental health.',
    ),
  },
  {
    value: 'MICROFINANCE',
    label: getText('Microfinance'),
    description: getText(
      'Nonprofits that offer financial services such as loans, savings, insurance, and fund transfers to entrepreneurs, small businesses, and individuals who lack access to traditional banking services.',
    ),
  },
  {
    value: 'POVERTY',
    label: getText('Poverty'),
    description: getText(
      'Nonprofits focused on bringing about an end to poverty through advocacy, education, and programming.',
    ),
  },
  {
    value: 'PRISON_REFORM',
    label: getText('Prison Reform'),
    description: getText(
      'Nonprofits focused on improving conditions inside of prisons, the effectiveness of the larger system, and/or implementing alternatives to incarceration.',
    ),
  },
  {
    value: 'RACE_ETHNICITY',
    label: getText('Race & Ethnicity'),
    description: getText(
      'Nonprofits focused on issues related to racial equity or eliminating racial/ethnic discrimination through education, advocacy, and programming.',
    ),
  },
  {
    value: 'RELIGION_SPIRITUALITY',
    label: getText('Religion & Spirituality'),
    description: getText(
      'May work on ethical issues, interfaith coalitions, or the intersection of culture and religion.',
    ),
  },
  {
    value: 'REPRODUCTIVE_HEALTH_RIGHTS',
    label: getText('Reproductive Health/Rights'),
    description: getText(
      'Nonprofits focused on supporting access to comprehensive sexual/reproductive health and rights.',
    ),
  },
  {
    value: 'RESEARCH_SOCIAL_SCIENCE',
    label: getText('Research & Social Science'),
    description: getText(
      'Nonprofits focused on research related to a variety of social, economic, educational, and political purposes.',
    ),
  },
  {
    value: 'RURAL_AREAS',
    label: getText('Rural Areas'),
    description: getText(
      'Nonprofits focused on programs and resources that support issues faced in rural areas, such as education, food access, farming, and sustainability.',
    ),
  },
  {
    value: 'SCIENCE_TECHNOLOGY',
    label: getText('Science & Technology'),
    description: getText(
      'Nonprofits focused on education, research, and policy related to science and technology, including access to technology and using data science and technology to solve world issues.',
    ),
  },
  {
    value: 'SENIORS_RETIREMENT',
    label: getText('Seniors & Retirement'),
    description: getText(
      'Nonprofits focused on providing support, guidance, education, and programming to help older adults and their families navigate life’s transitions and continue to be active, healthy, and engaged in the community.',
    ),
  },
  {
    value: 'SEXUAL_ABUSE_HUMAN_TRAFFICKING',
    label: getText('Sexual Abuse & Human Trafficking'),
    description: getText(
      'Nonprofits focused on preventing sexual abuse and human trafficking, as well as providing comprehensive services to survivors.',
    ),
  },
  {
    value: 'SPORTS_RECREATION',
    label: getText('Sports & Recreation'),
    description: getText(
      'Nonprofits focused on promoting education and an active, healthy lifestyle by providing opportunities to participate in sports, recreation, and extracurricular activities.',
    ),
  },
  {
    value: 'SUBSTANCE_ABUSE_ADDICTION',
    label: getText('Substance Use & Addiction'),
    description: getText(
      'Nonprofits focused on prevention of and treatment for substance use and addiction through programming and education.',
    ),
  },
  {
    value: 'TRANSPARENCY_OVERSIGHT',
    label: getText('Transparency & Oversight'),
    description: getText(
      'Nonprofits focused on preventing or exposing corruption in government and business by promoting transparency and oversight.',
    ),
  },
  {
    value: 'TRANSPORTATION',
    label: getText('Transportation'),
    description: getText(
      'Nonprofits focused on planning, design, implementation, and access to and operation of transportation such as walking, biking, mass transit, road, air, marine, etc.',
    ),
  },
  {
    value: 'TRAVEL_HOSPITALITY',
    label: getText('Travel & Hospitality'),
    description: getText(
      'Nonprofits focused on travel and hospitality for individual and community empowerment, offering volunteer opportunities abroad, hospitality programming opportunities for different populations, travel scholarships, and more.',
    ),
  },
  {
    value: 'URBAN_AREAS',
    label: getText('Urban Areas'),
    description: getText(
      'Nonprofits focused on programs and resources that support issues faced in large cities, such as housing, poverty, and transportation.',
    ),
  },
  {
    value: 'VETERANS',
    label: getText('Veterans'),
    description: getText(
      'Nonprofits focused on supporting returning/retired military veterans through programming and services.',
    ),
  },
  {
    value: 'VICTIM_SUPPORT',
    label: getText('Victim Support'),
    description: getText(
      'Nonprofits focused on upholding the rights of and supporting those harmed by crime and crisis by providing programming, advocacy, legal support.',
    ),
  },
  {
    value: 'VOLUNTEERING',
    label: getText('Volunteering'),
    description: getText(
      'Nonprofits focused on creating and offering meaningful opportunities for volunteers.',
    ),
  },
  {
    value: 'WATER_SANITATION',
    label: getText('Water & Sanitation'),
    description: getText(
      'Nonprofits focused on providing access to clean drinking water, water conservation, improving watersheds, access to timely and accurate water-quality information, and stewardship of waterways.',
    ),
  },
  {
    value: 'WOMEN',
    label: getText('Women'),
    description: getText(
      'Nonprofits focused on creating societal change, eliminating discrimination, and achieving and protecting the equal rights of women and girls in all aspects of social, political, and economic life.',
    ),
  },
];
export const V8_EMPLOYER_ORG_TYPES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true,
  },
  {
    value: 'ARTS_CULTURE_AND_HUMANITIES',
    label: getText('Arts, Culture, and Humanities'),
    description: `Organizations include historical societies, landmark preservation, libraries, museums, and performing arts organizations.`,
  },
  {
    value: 'FOUNDATION_OR_GRANTMAKING_INSTITUTION',
    label: getText('Foundation or Grantmaking Institution'),
    description: `A nonprofit or charitable trust that makes grants to organizations, institutions, or individuals for charitable purposes. Organizations include community foundations, private foundations, and grantmaking public charities.`,
  },
  {
    value: 'HIGHER_EDUCATION',
    label: getText('Higher Education'),
    description: `Organizations include academies, colleges, conservatories, institutes of technology, seminaries, and universities.`,
  },
  {
    value: 'HOSPITAL_CLINIC_OR_MEDICAL_RESEARCH_FACILITY',
    label: getText('Hospital, Clinic, or Medical Research Facility'),
    description: `Health care institutions that provide medical treatment. Organizations include general hospitals, teaching hospitals, specialized hospitals, medical centers, and medical research institutes.`,
  },
  {
    value: 'ISSUE_BASED_ORGANIZATION',
    label: getText('Issue-Based Organization (select to see more)'),
    subTypes: ISSUE_BASED_ORGANIZATION_SUB_TYPES,
    subTypeLabel: getText('Issue-Based Organization'),
  },
  {
    value: 'MEMBERSHIP_ORGANIZATION',
    label: getText('Membership Organization'),
    description: `Connects people or institutions around an interest, geographical location, or profession, often for a fee or dues. Organizations include professional and trade associations, political parties, and voluntary associations.`,
  },
  {
    value: 'PUBLIC_OR_PRIVATE_SCHOOL_K12',
    label: getText('Public or Private School, K-12 (select to see more)'),
    subTypes: [
      {
        value: '',
        label: getText('My school is a...'),
        disabled: true,
        hidden: true,
      },
      {
        value: 'PUBLIC_NONPROFIT_CHARTER_SCHOOL',
        label: getText('Public Nonprofit Charter School'),
      },
      {
        value: 'PRIVATE_NONPROFIT_SCHOOL',
        label: getText('Private Nonprofit School'),
      },
      {
        value: 'PUBLIC_INSTITUTION_LOCAL_GOV',
        label: getText(
          'Public Institution Funded and Operated by Local Government',
        ),
      },
    ],
    subTypeLabel: getText('School'),
  },
  {
    value: 'RELIGIOUS_OR_FAITH_BASED_INSTITUTION',
    label: getText('Religious or Faith-Based Institution'),
    description: `Exists to support and manage the practice of a specific set of religious beliefs. Organizations include churches, mosques, synagogues, and temples.`,
  },
  {
    value: 'THINK_TANK_OR_POLICY_INSTITUTE',
    label: getText('Think Tank or Policy Institute'),
    description: `Performs research and advocacy concerning issue-oriented topics such as social policy, political strategy, economics, military, technology, and culture.`,
  },
];
export const V8_GENDERS = [
  {
    name: 'FEMALE',
    label: 'Female',
  },
  {
    name: 'NON_BINARY',
    label: 'Gender Non-Binary, Gender Non-Conforming, or Genderqueer',
  },
  {
    name: 'MALE',
    label: 'Male',
  },
  {
    name: 'TRANSGENDER',
    label: 'Transgender',
  },
  {
    name: 'OTHER',
    label: 'Prefer to self-describe',
  },
];
export const V8_RACES_AND_ETHNICITIES = [
  {
    name: 'NATIVE',
    label:
      'Alaska Native, American Indian, Indigenous American, or Native American',
  },
  {
    name: 'ARABIC',
    label: 'Arab American, Middle Eastern, or North African',
  },
  {
    name: 'ASIAN',
    label: 'Asian American, East Asian, South Asian, or South East Asian',
  },
  {
    name: 'BLACK',
    label: 'Black, African American, African, or African Descent',
  },
  {
    name: 'LATIN',
    label: 'Latina/o/x, Chicana/o/x, or Hispanic American',
  },
  {
    name: 'PACIFIC_ISLAND',
    label: 'Native Hawaiian or Other Pacific Islander',
  },
  {
    name: 'WHITE',
    label: 'White or European Descent',
  },
  {
    name: 'OTHER',
    label: 'Another race, ethnicity, or origin',
  },
];
export const V8_AGES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true,
  },
  {
    value: 'LT_21',
    label: 'Under 21',
  },
  {
    value: '21_TO_29',
    label: '21-29',
  },
  {
    value: '30_TO_39',
    label: '30-39',
  },
  {
    value: '40_TO_49',
    label: '40-49',
  },
  {
    value: '50_TO_59',
    label: '50-59',
  },
  {
    value: 'GTE_60',
    label: '60 or older',
  },
];
